/*
* According to deprecation warning, the following should be used instad, but this will create a forever redirection loop
* var createHistory = require("history").createHashHistory;
*/

var createHistory   = require('history/createBrowserHistory');

module.exports = createHistory();
